var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "7 7 30 30",
    fill: "none",
    stroke: "#929497",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.491 21.994c0-.392-.036-.771-.097-1.15l1.594-.919-2.215-3.844L26.18 17a6.693 6.693 0 00-1.984-1.15V14H19.78v1.848c-.73.258-1.399.662-1.983 1.151l-1.582-.93L14 19.925l1.594.918c-.073.38-.11.76-.11 1.15 0 .393.037.772.098 1.152l-1.582.93 2.214 3.844L17.808 27c.584.49 1.254.881 1.984 1.15V30h4.416v-1.849c.73-.269 1.4-.66 1.984-1.15l1.594.918L30 24.075l-1.594-.918a9.17 9.17 0 00.085-1.163z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 3
  })));
}

export default SvgSettings;